export class HabitDataQueryModel {
    public Date: Date;
    public DateToDisplay: string;
    public HabitTypeID: number;
    public WeekNo: number;
}
